var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSortNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "#BDCBD9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60257 7.43589V2.58204L0.712817 4.47179L0 3.76924L3.10255 0.666687L6.2051 3.76924L5.4923 4.47179L3.60255 2.58204V7.43589H2.60257ZM6.891 13.3333L3.78845 10.2308L4.50125 9.52822L6.39102 11.418V6.56412H7.39098V11.418L9.28075 9.52822L9.99355 10.2308L6.891 13.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortNew);
export default __webpack_public_path__ + "static/media/icon-sortNew.3fb7adad72c6104e91b8d7042a691aaf.svg";
export { ForwardRef as ReactComponent };